<template>
  <standard-layout v-if="customer" :header="customer.name" type="customer">
    <template v-slot:main>
      <customer-detail :customer="customer" :panel-layout="true"></customer-detail>
      <div class="container" v-if="orders.length > 0">
        <div class="h5 text-primary mt-4">Bestellungen</div>
        <order-list :orders="orders"/>
      </div>
      <div class="container" v-if="reservations.length > 0">
        <div class="h5 text-primary mt-4">Reservierungen</div>
        <reservation-list :reservations="reservations"/>
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
import CustomerDetail from "@/components/customer/CustomerDetail";
import {describe} from "@/utils/order-utils";
import OrderList from "@/components/order/OrderList";
import ReservationList from "@/components/reservation/ReservationList";

export default {
  components: {OrderList, CustomerDetail, StandardLayout, ReservationList},
  props: {
    id: String
  },
  data() {
    return {
      customer: null,
      orders: [],
      reservations: []
    }
  },
  computed: {},
  methods: {
    reloadCustomer() {
      this.$api.get(`/customers/${this.id}`)
          .then(res => this.customer = res.data)
          .catch(error => this.handleError(error))
    }
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.reloadCustomer()
      }
    },
    customer(newVal) {
      if (newVal) {
        this.$api.get(`/orders?customer=${newVal.id}`)
            .then(res => {
              this.orders = res.data.map(o => {
                return {...o, description: describe(o)}
              })
            })
            .catch(error => this.handleError(error))
        this.$api.get(`/reservations?customer=${newVal.id}`)
            .then(res => {
              this.reservations = res.data
            })
            .catch(error => this.handleError(error))
      }
    }
  }
}
</script>

